import {
  ADD_LANGUAGE,
  EDIT_LANGUAGE,
  LIST_LANGUAGE,
  VIEW_LANGUAGE,
  DELETE_LANGUAGE,
  LANGUAGE_SUCCESS,
  LANGUAGE_ERROR,
} from "./actionTypes";

const initialState = {
  successMsg: null,
  error: null,
  loading: false,      // General loading for add/list/view
  editLoading: false,  // Specific loading state for edit action
};

const configurationsLanguages = (state = initialState, action) => {
  switch (action.type) {
    // Add Language
    case ADD_LANGUAGE:
      return {
        ...state,
        loading: true,   // Set loading to true when adding
        editLoading: false, // Reset editLoading
        successMsg: null,
        error: null,
      };

    // Edit Language
    case EDIT_LANGUAGE:
      return {
        ...state,
        loading: false,  // Reset general loading
        editLoading: true, // Set editLoading to true when editing
        successMsg: null,
        error: null,
      };

    // List Language
    case LIST_LANGUAGE:
      return {
        ...state,
        loading: true,   // Set loading to true when listing
        editLoading: false, // Reset editLoading
        successMsg: null,
        error: null,
      };

    // View Language
    case VIEW_LANGUAGE:
      return {
        ...state,
        loading: false,  // Reset general loading
        editLoading: false, // Ensure editLoading is false
        successMsg: null,
        error: null,
      };

    // Delete Language
    case DELETE_LANGUAGE:
      return {
        ...state,
        loading: true,   // Use loading for delete action
        editLoading: false, // Reset editLoading
        successMsg: null,
        error: null,
      };

    // Handle success
    case LANGUAGE_SUCCESS:
      return {
        ...state,
        loading: false,   // Reset loading on success
        editLoading: false, // Reset editLoading on success
        successMsg: action.payload,
      };

    // Handle error
    case LANGUAGE_ERROR:
      return {
        ...state,
        loading: false,   // Reset loading on error
        editLoading: false, // Reset editLoading on error
        error: action.payload,
      };

    default:
      return state;
  }
};

export default configurationsLanguages;
